import {Component, Input, OnInit} from '@angular/core';
import {faBoxOpen, faPallet, faCogs, faWeightHanging} from '@fortawesome/free-solid-svg-icons';
import {ShipmentInfo} from '../../../../models/shipment-info.model';
import {FormService} from '../../../../services/form.service';
import {Dienst} from '../../../../models';

@Component({
  selector: 'lib-current-values',
  templateUrl: './current-values.component.html',
  styleUrls: ['./current-values.component.css']

})
export class CurrentValuesComponent implements OnInit {
  faBoxOpen = faBoxOpen;
  faPallet = faPallet;
  faCogs = faCogs;
  faWeightHanging = faWeightHanging;

  dienste: Dienst[] = [];
  displayDiensteToCorrect: Dienst[];

  @Input() shipmentInfoDetails: ShipmentInfo;
  @Input() allowedDienste: Dienst[];

  public colli;
  public palette;
  public gewicht;
  public displayDienste;

  constructor(private formService: FormService) {
  }

  ngOnInit(): void {
    if (this.shipmentInfoDetails.dienste !== null) {
      this.shipmentInfoDetails.dienste.forEach((dienste: Dienst) => {
        this.dienste.push(dienste);
      });
    }
    let filteredAllowed = this.allowedDienste.map((allowedDienst: Dienst) => {
      return allowedDienst.bezeichnung;
    });
    this.displayDiensteToCorrect = this.dienste.filter((displayDienste: Dienst) => filteredAllowed.includes(displayDienste.bezeichnung));

    this.formService.allowedDienste.next(this.displayDiensteToCorrect);

    this.colli = this.shipmentInfoDetails.colli;
    this.palette = this.shipmentInfoDetails.paletten;
    this.gewicht = this.shipmentInfoDetails.gesamtgewicht;
    this.displayDienste = this.shipmentInfoDetails.dienste;

  }

  showDienste(param: any) {
    const dienste = [];
    param.map((dienst: Dienst) => {
      if (dienst.anzeigeKuerzel !== null) {
        dienste.push(dienst.anzeigeKuerzel);
      }
    });
    return dienste.join(', ');
  }

}
